export const baseAnimeParams = {
    delay: 0,
    duration: 1500,
    easing: 'easeOutExpo',
};
